import React from "react";

function SidebarCheckbox({props}) {
    return <label htmlFor="sidebar-checkbox" className="sidebar-toggle" />
}
export default SidebarCheckbox